import React, {useEffect} from 'react';
import styled from "styled-components";
import {Container, Row, Col, Form} from "react-bootstrap";

// form

import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import {apiEndPoints} from "../api/network/apiEndPoints";
import {postForm} from "../api/redux/contact";

const ContactForm = ({data}) => {

    const dispatch = useDispatch();
    const responseData = useSelector(state => state.contact);

    const {register, handleSubmit, formState, reset} = useForm({mode: 'all'});

    const success = (msg) => toast.success(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    const error = (msg) => toast.error(msg, {
        position: "top-right",
        autoClose: 4000,
        closeOnClick: true,
        progress: undefined,

    });

    const onSubmit = (e) => {

        let api_services = apiEndPoints.FORM_SUBMIT;

        var formData = new FormData();
        formData.append('name', e?.name);
        formData.append('email', e?.email);
        formData.append('phone', e?.phone);
        formData.append('message', e?.message);
        formData.append('form_id', 'contact-form');

        if (e.email !== '' && e.name !== '' && e.phone !== '') {
            dispatch(postForm([api_services, formData]));
            success('Successfully Submitted')
            reset();
        }
    };
    let count = 0;
    const onError = (errors) => {
        Object.values(errors).forEach((error) => {
            count++;
        });
        if (count > 0) {
            toast.error('please fill out the correct inputs');
        }
        count = 0;
    };
    useEffect(() => {
        if (responseData && responseData?.error !== '') {
            error(responseData?.error)
        }
        if (responseData && responseData?.success !== '') {
            success(responseData?.success)
        }

    }, [responseData])


    return (
        <StyledContactForm>
            <Container>
                <Row>

                    <Col className={'p-0'} md={12}>
                        <Form>
                            <div className="form-group">
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Control
                                        className={
                                            formState?.errors?.name?.message
                                                ? "has-error form-control-lg"
                                                : "form-control-lg"
                                        }
                                        {...register("name", {
                                            required: "Please enter your full name",
                                            pattern: {
                                                value: /([A-Za-z])\w+/,
                                                message: "Please enter your full name",
                                            },
                                        })}
                                        type="text"

                                        placeholder="Name*"
                                    />
                                </Form.Group>
                            </div>

                            <div className="form-group">
                                <Form.Group controlId="formBasicPhone">
                                    <Form.Control
                                        className={
                                            formState?.errors?.phone?.message
                                                ? "has-error form-control-lg"
                                                : "form-control-lg"
                                        }
                                        {...register("phone", {
                                            required: {
                                                value: true,
                                                message: "Please enter your phone number",
                                            },
                                            pattern: {
                                                value: /^01[0-9]{9}$/,
                                                message: "Please enter a valid 11 digit phone number",
                                            },
                                        })}
                                        type="number"

                                        placeholder="Phone Number*"/>
                                </Form.Group>
                            </div>
                            <div className="form-group">
                                <Form.Group controlId="formBasicEmail">

                                    <Form.Control
                                        className={
                                            formState?.errors?.email?.message
                                                ? "has-error form-control-lg"
                                                : "form-control-lg"
                                        }
                                        {...register("email", {
                                            required: {
                                                value: true,
                                                message: "Please enter your email",
                                            },
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: "Please enter a valid email address",
                                            },
                                        })}
                                        type="email"
                                        placeholder="Email Address*"/>
                                </Form.Group>
                            </div>

                            <div className="form-group">
                                <Form.Group controlId="formBasicMessage">

                                    <Form.Control
                                        className={
                                            formState?.errors?.message?.message
                                                ? "has-error form-control-lg"
                                                : "form-control-lg"
                                        }
                                        {...register("message", {
                                            required: {
                                                message: "Please enter your message",
                                            },
                                        })}

                                        type="textarea"
                                        placeholder="Message"/>
                                </Form.Group>
                            </div>

                            <div className={`'form-group'}`}>
                                <div>
                                    <button onClick={handleSubmit(onSubmit, onError)} >Submit</button>
                                </div>

                            </div>

                        </Form>
                    </Col>
                </Row>


            </Container>
        </StyledContactForm>
    );
};

const StyledContactForm = styled.div`
    .query {
        margin-bottom: 30px;
    }

    h3 {
        font-size: 14px;
        font-weight: bold;
        line-height: 21px;
        color: #000;
        margin-bottom: 15px;
        //padding-bottom: 10px;
    }

    button {
        height: 40px;
        width: 120px;
        background: transparent;
        color: #000;
        font-size: 14px;
        font-weight: bold;
        line-height: 21px;
    }


    input {
        &:focus {
            outline: none;
        }
    }

    .form-control {
        font-size: 12px;
        line-height: 21px;
        font-weight: 400;
        background-color: transparent;
        border: none;
        border-bottom: 1px solid rgba(22, 31, 19, 0.1);
        margin-bottom: 30px;
        padding-bottom: 15px;
        //color: #161F13;
        padding-left: 0;

        &::placeholder {
            font-size: 12px;
            line-height: 21px;
            font-weight: 400;
            color: rgba(28, 55, 0, 0.5);
        }

        &:focus {
            border-bottom: 1px solid rgba(22, 31, 19, 0.2);
        }
    }

    .form__phoneEmail {
        display: flex;
        gap: 20px;

        input {
            width: 49% !important;
        }

        @media (max-width: 767px) {
            gap: 0;
            flex-direction: column;
            width: 100%;

            input {
                width: 100% !important;
            }
        }

    }

    input[type="textarea"] {
        padding-top: 10px;
        padding-bottom: 80px;
    }


    p {
        //color: #FFFDFB;
        margin-bottom: 28px;

        @media (max-width: 767px) {
            margin-bottom: 40px;
        }
    }

    /* Tablet desktop :768px. */
    @media (min-width: 768px) and (max-width: 991px) {
        margin-top: 30px;

    }
    @media (max-width: 767px) {
        .col-md-12 {
            padding: 0;
            margin-top: 30px;
        }
    }

`;

export default React.memo(ContactForm);
